import { render, staticRenderFns } from "./ErrorPage.vue?vue&type=template&id=f9cac0a6"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"
import style0 from "./ErrorPage.vue?vue&type=style&index=0&id=f9cac0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports